import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DownloadItemEvent } from "../export-download-group-row/export-download-group-row.component";
import { CartItem, CartItemType } from "../../../../_core/state/cart/cart.model";
import { getExportTypeTranslations } from "../../../../_core/services/localization.service";
import { TaskStatus } from "../../../../../../../api/src/encode/encode-task.entity";
import { ExportDownloadUtils } from "../export-download.utils";

@Component({
  selector: 'app-export-download-subgroup-row',
  templateUrl: './export-download-subgroup-row.component.html',
  styleUrl: './export-download-subgroup-row.component.scss'
})
export class ExportDownloadSubgroupRowComponent {
	protected readonly CartItemType = CartItemType;
	protected readonly TaskStatus = TaskStatus;
	protected readonly ExportDownloadUtils = ExportDownloadUtils;
	readonly EXPORT_TYPE_LABELS = getExportTypeTranslations();

	@Input() subgroup: any;

	@Output() downloadItem: EventEmitter<DownloadItemEvent> = new EventEmitter<DownloadItemEvent>();
	@Output() downloadByGroupId: EventEmitter<CartItem> = new EventEmitter<CartItem>();
	@Output() downloadByPackageId: EventEmitter<CartItem> = new EventEmitter<CartItem>();
	@Output() retryTasks: EventEmitter<void> = new EventEmitter<void>();

	constructor() {}

}
